export default "__VITE_ASSET__BGa5xD5L__"